import { createSelector } from 'reselect';

import { SEARCH_FORM } from '@location/model';
import { SEARCH_FORM_KEY } from '@location/constants';
import { FIELD_KEY } from '@location/components/FormInputs/constants';
import getPropFromModule from './getPropFromModule';
import getSelectedArea from './getSelectedArea';
import getSelectedCity from './getSelectedCity';

const { CITY } = SEARCH_FORM_KEY;
const { AREA, CITY_NAME } = FIELD_KEY;

const getForm = createSelector(
  state => getPropFromModule(state, SEARCH_FORM),
  form => form.toJS(),
);

const getSearchForm = createSelector(
  getForm,
  getSelectedCity,
  getSelectedArea,
  (searchForm, city, area) => ({
    ...searchForm,
    [CITY_NAME]: city?.name || '',
    [CITY]: city,
    [AREA]: area,
  }),
);

export default getSearchForm;
